// Recursively sanitize all object keys to be Firebase-safe
const sanitizeKeysDeep = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map(sanitizeKeysDeep);
  } else if (obj !== null && typeof obj === 'object') {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      const safeKey = String(key).replace(/[.#$/[\]]/g, '_');
      acc[safeKey] = sanitizeKeysDeep(value === undefined ? null : value);
      return acc;
    }, {});
  }
  return obj === undefined ? null : obj;
};

export default sanitizeKeysDeep;